/**
 * Custom extended theme JS.
 * Loaded globally from layout/theme.liquid.
 */
(function () {
  'use strict';

  /**
   * Smooth-scrolls the page so the TOP of `element` sits just below the
   * sticky header. Measured at click time, so it's correct no matter how
   * the page content above has shifted.
   *
   * Deliberately a local copy: anchor-cta-button.js keeps its own version
   * private inside its IIFE, so there is nothing global to reuse.
   */
  function scrollToElement(element, headerOffset) {
    var pagePosition =
      element.getBoundingClientRect().top + window.scrollY - headerOffset;

    window.scrollTo({
      top: Math.max(0, pagePosition), // never scroll above the top of the page
      behavior: 'smooth',
    });
  }

  // Where bundle links go when there's no bundle on the current page.
  // Path only, so it stays on whatever domain the shopper is browsing
  // (live store, *.myshopify.com, or a theme preview).
  var BUNDLE_FALLBACK_PRODUCT = 'products/beach-foam-copy';

  /**
   * True only if the element is actually rendered — present in the DOM AND
   * taking up space. The Kaching app can leave an empty or hidden
   * <kaching-bundle> behind, which we must not try to scroll to.
   */
  function isRendered(element) {
    return !!element && element.getClientRects().length > 0;
  }

  /**
   * Builds a storefront URL from a path, respecting the active market/locale
   * prefix (e.g. "/en-ca/") when Shopify exposes one.
   */
  function storefrontUrl(path) {
    var root = '/';
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      root = window.Shopify.routes.root;
    }
    if (root.charAt(root.length - 1) !== '/') root += '/';
    return root + path;
  }

  /**
   * Plain links pointing at the bundle (announcement bar, menus) smooth-scroll
   * to the Kaching bundle instead of doing a broken native hash jump — there is
   * no element with id="kaching-bundle", only the <kaching-bundle> tag.
   *
   * When the current page has no bundle to scroll to, the link sends the
   * shopper to the bundle PDP instead of doing nothing.
   *
   * Listening on `document` means links added later — by the theme editor or by
   * the Kaching app itself — are covered without re-running anything.
   */
  document.addEventListener('click', function (event) {
    if (!event.target || !event.target.closest) return;

    var link = event.target.closest('a[href="#kaching-bundle"]');
    if (!link) return;

    var kachingBundle = document.querySelector('kaching-bundle');

    // No bundle here (or it's hidden) — go to the bundle PDP.
    if (!isRendered(kachingBundle)) {
      event.preventDefault();
      window.location.href = storefrontUrl(BUNDLE_FALLBACK_PRODUCT);
      return;
    }

    event.preventDefault();

    var headerOffset =
      (parseInt(
        getComputedStyle(document.documentElement).getPropertyValue('--header-height'),
        10
      ) || 150) - 150;

    scrollToElement(kachingBundle, headerOffset);
  });
})();
